import { render, staticRenderFns } from "./UserOnboardingDocumentPdf.vue?vue&type=template&id=19c0db32&scoped=true"
import script from "./UserOnboardingDocumentPdf.vue?vue&type=script&lang=js"
export * from "./UserOnboardingDocumentPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0db32",
  null
  
)

export default component.exports